<section>
    <div class="parentStepOrder" *ngFor="let order of orderedPaymentList; let i = index" #childDiv>
        <div class="childStepOrder">
            <p>
                {{'html-Pay-Title' | translation | async }} {{ i + 1 }}.
                {{'html-Total-Pay-Title' | translation | async }}
                {{ currency }} {{ order.amount }}
            </p>
            <span class="statusOrderContainer"
                [ngClass]="{'pendingOrder': order.status == 'PENDIENTE', 'approvedOrder': order.status == 'APROBADA'}">
                {{ order.status }}
            </span>
        </div>
        <app-copy-to-clipboard 
            *ngIf="order.status == 'PENDIENTE'" 
            [value]="order.checkoutLink ">
        </app-copy-to-clipboard>
    </div>
    <article class="importantInfo">
        <p *ngIf="isPending()" innerHTML="{{ 'html-important' | translation | async | uppercase }}"></p>
        <span innerHTML="{{ importantMessage | translation | async }}"></span>
    </article>
</section>